import { Type } from '@angular/core';

import { LooseArticleCategory } from 'app/constants/loose-article-categories.data';

export const enum ModalCheckboxFunction {
  'SKIP_NEXT_STEP',
  'OPEN_NEXT_MODAL'
}

export enum ModalFooterLinkFunction {
  RESET_FORM = 'RESET_FORM',
  HIDE_LINK = 'HIDE_LINK',
  GO_TO_DASHBOARD = 'GO_TO_DASHBOARD'
}

export type ModalGroup =
  'customer' |
  'contactPerson' |
  'objekt' |
  'customerAll' |
  'individualCondition' |
  'newCondition' |
  'article' |
  'freeArticle' |
  'addArticleToOffer' |
  'addFreeArticleToOffer' |
  'expirationDate' |
  'password' |
  'send-success' |
  'branch' |
  'inviteMember' |
  'createSuperAdmin' |
  'measurementCalculations' |
  'offerPreview' |
  'rfp' |
  'answeredRFPsPreview' |
  'looseArticle' |
  'closedOffer' |
  'deleteAccount' |
  'addFavorite' |
  'editFavorite' |
  'addFreeArticle' |
  'editFreeArticle' |
  'editArticleInOffer' |
  'editFreeArticleInOffer' |
  'branch-sftp';

export type ModalContentType = 'list' | 'form' | 'formUpdate';

export type ModalStepInputType = LooseArticleCategory | undefined;

export interface ModalLink {
  text?: string;
  function?: ModalFooterLinkFunction;
  modalId?: string;
  disabled?: boolean;
}

export interface ModalBreadcrumb {
  text: string;
  visited?: boolean;
}

export interface ModalStep {
  id: string;
  class?: string;
  header?: {
    modalTitleOverride?: string;
    title?: string;
    image?: string;
    link?: ModalLink;
    breadcrumb?: ModalBreadcrumb;
  };
  body: {
    componentType: Type<any>;
    data?: string;
    resetMinHeight?: boolean;
  };
  footer?: {
    saveBtnName?: string;
    showCancelBtn?: boolean;
    link?: ModalLink;
    checkbox?: {
      text?: string;
      modalId?: string; // Only applies if function is ModalCheckboxFunction.OPEN_NEXT_MODAL
      function: ModalCheckboxFunction;
    };
    hideFooter?: boolean;
  };
}

export interface Modal {
  id: string;
  groupId: string;
  title: string;
  steps: ModalStep[];
}

export interface Multimodal {
  modals: Modal[];
  currentModalId?: string;
}

export interface ModalShowArgs {
  group: ModalGroup;
  contentType: ModalContentType;
  isBasic: boolean;
}
